<template>
  <div>
    <div style="position: relative;">
      <div
        class="seat-progress-bar bg-grey-5"
      >
        <div
          class="bg-primary"
          :style="{ width: (showing.ticketsSold / showing.screen.seatCount * 100) + '%' }"
        />
        <div
          :class="'bg-' + availableColor"
          :style="{ width: (seatsAvailable / showing.screen.seatCount * 100) + '%' }"
        />
        <div
          v-if="showing.reservedSeating && socialDistanceCount"
          class="bg-grey-4"
          :style="{ width: (socialDistanceCount / showing.screen.seatCount * 100) + '%' }"
        />
        <div
          v-if="showing.reservedSeating"
          class="bg-grey-5"
          :style="{ width: (unavailableCount / showing.screen.seatCount * 100) + '%' }"
        />
        <div
          v-else
          class="bg-grey-5"
          :style="{ width: ((showing.heldSeats || 0) / showing.screen.seatCount * 100) + '%' }"
        />
      </div>
      <div
        v-if="currentSite.showAttendancePredictionInPos"
        style="position: absolute; bottom: -13px; padding-left: 2px;"
        :style="{ left: (showing.predictedAttendance / showing.screen.seatCount * 100) + '%' }"
        class="text-grey-8"
      >
        <q-icon
          class="col"
          name="arrow_drop_up"
          size="sm"
        />
      </div>
    </div>
    <div
      v-if="showLabels"
      class="row justify-between q-my-lg"
    >
      <div
        class="col column items-center text-primary q-mx-sm"
        style="flex-basis: auto;"
        :style="{ 'flex-grow': (showing.ticketsSold / showing.screen.seatCount * 100) }"
      >
        <div class="text-h4 text-center">
          {{ showing.ticketsSold }}
        </div>
        <div class="text-bold text-center">
          {{ $t('status.sold') }}
        </div>
      </div>
      <div
        class="col column items-center q-mx-md"
        :class="'text-' + availableColor"
        style="flex-basis: auto;"
        :style="{ 'flex-grow': (seatsAvailable / showing.screen.seatCount * 100) }"
      >
        <div class="text-h4 text-center">
          {{ seatsAvailable }}
        </div>
        <div class="text-bold text-center">
          {{ $t('status.available') }}
        </div>
      </div>
      <div
        v-if="showing.reservedSeating && socialDistanceCount"
        class="col column items-center q-mx-md text-grey-6"
        style="flex-basis: auto;"
        :style="{ 'flex-grow': (socialDistanceCount / showing.screen.seatCount * 100) }"
      >
        <div class="text-h4 text-center">
          {{ socialDistanceCount }}
        </div>
        <div class="text-bold text-center">
          {{ $t('common.socialDistance') }}
        </div>
      </div>
      <div
        v-if="showing.reservedSeating && unavailableCount"
        class="col column items-center q-mx-md text-grey-7"
        style="flex-basis: auto;"
        :style="{ 'flex-grow': (unavailableCount / showing.screen.seatCount * 100) }"
      >
        <div class="text-h4 text-center">
          {{ unavailableCount }}
        </div>
        <div class="text-bold text-center">
          {{ $t('status.unavailable') }}
        </div>
      </div>
      <div
        v-if="!showing.reservedSeating"
        class="col column items-center text-grey-7 q-mx-sm cursor-pointer"
        style="flex-basis: auto;"
        :style="{ 'flex-grow': (heldSeats / showing.screen.seatCount * 100) }"
        @click="editHeldCount = !editHeldCount"
      >
        <div
          class="text-h4 text-center"
          style="position: relative;"
        >
          {{ heldSeats }}
          <q-icon
            class="absolute"
            style="right: -25px; top: 0"
            name="edit"
            size="xs"
          />
        </div>
        <div class="text-bold text-center">
          Held
        </div>
      </div>
      <div
        class="col column items-center q-ml-md"
        style="flex-basis: auto;"
        :style="{ 'flex-grow': (showing.screen.seatCount / 15 / showing.screen.seatCount * 100) }"
      >
        <div class="text-h4 text-center">
          {{ showing.screen.seatCount }}
        </div>
        <div class="text-bold text-center">
          {{ $t('collection.total') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Showing from 'src/models/showing/Showing'

export default {
  name: 'ShowingProgressBar',
  props: {
    showing: {
      type: Showing,
      required: true
    },
    showLabels: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'sm'
    }
  },
  computed: {
    seatsAvailable () {
      if (this.showing.reservedSeating) {
        return this.showing.seatsRemaining
      } else {
        return this.showing.seatsRemaining
      }
    },
    socialDistanceCount () {
      return this.showing.seatsRemainingWithoutSocialDistancing - this.showing.seatsRemaining
    },
    unavailableCount () {
      return this.showing.screen.seatCount - this.showing.seatsRemainingWithoutSocialDistancing - this.showing.ticketsSold
    },
    availableColor () {
      const ratio = this.seatsAvailable / (this.showing.screen.seatCount - this.showing.heldSeatCount)

      if (ratio < 0.25) {
        return 'negative'
      } else if (ratio < 0.5) {
        return 'warning'
      } else {
        return 'positive'
      }
    }
  },
  configuration: ['currentSite']
}

</script>

<style lang="scss" scoped>
.seat-progress-bar {
  height: 4px;
  overflow: hidden;
}
.seat-progress-bar > div {
  top: -5px;
  position: relative;
  display: inline-block;
  height: 10px;
}
</style>
